import React from 'react'
import {Checkbox as AntCheckbox} from 'antd'
import './index.scss'

/*
  Need to return a class component to avoid the following warning
  when used in AntD form:
  Function components cannot be given refs.
  Attempts to access this ref will fail. Did you mean to use React.forwardRef()?
*/
class Checkbox extends React.Component {
  render() {
    const {label, description, ...rest} = this.props
    return (
      <AntCheckbox className="checkbox" {...rest}>
        <span className="label">{label}</span>
        {description && <span className="description">{description}</span>}
      </AntCheckbox>
    )
  }
}

export default Checkbox
